<template>
<v-row :class="['im-result', 'regular', getClass()]" no-gutters>
    <v-col cols="4">
        <v-row align="center" no-gutters>
            <v-col xs1 class="px-2">{{ item.id }}</v-col>
            <v-col cols="12" md="3" order-md="1" order="2" class="px-2 text-xs-left">{{ item.resource_id }}</v-col>
            <v-col cols="12" md="4" order-md="2" order="1" class="px-2 text-capitalize">{{ item.resource_owner }}</v-col>
            <v-col cols="12" md="4" order-md="2" order="1" class="px-2 text-capitalize">{{ item.resource_type }}</v-col>
        </v-row>
    </v-col>
    <v-col cols="8">
        <v-row align="center" no-gutters>
            <v-col cols="6" class="px-2">
                <div class="test-ellipse" v-html="item.body"></div>
            </v-col>

            <v-col cols="3" class="px-2 text-center">{{ getDate(item.created_at) }}</v-col>
            <v-col cols="3" class="px-2">
                <div class="d-flex align-center" v-if="item.author">
                    <v-avatar size="36" class="mx-1">
                        <img v-if="item.author.avatar" :src="item.author.avatar">
                        <v-icon size="36" v-else>face</v-icon>
                    </v-avatar>
                    <div class="px-2">
                        <div class="important">{{ item.author.name }}</div>
                        <div class="faded">{{ item.author.id }}</div>
                    </div>
                </div>
                <div v-else class="important text-center">N/A</div>
            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js";
export default {
    props: {
        item: {
            type: Object,
            default: defaults.comment_item
        },
    },
    methods: {
        getDate(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('YYYY-MM-DD');
        },
        getClass() {
            switch (this.item.status) {
            case 'approved':
                return 'im-result-success';
            case 'pending':
                return 'im-result-warning';
            case 'rejected':
                return 'im-result-danger';
            default:
                return '';
            }
        },
        emitClick() {
            this.$emit('click');
        },
    }
}
</script>

<style>
.item:hover {
    background-color: #ECEFF1 !important;
}

.cursor:hover {
    cursor: pointer;
}

.test-ellipse {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 43px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 1;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
